// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9e1f0648","981":"6a119b48"}[chunkId] + ".chunk.js";
};